

























import { defineComponent, PropType } from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ProfileCard from '../ProfileCard.vue';
import { EditableSection } from '../editableProfileSections';

export default defineComponent({
	components: {
		FontAwesomeIcon,
		ProfileCard,
	},
	props: {
		isCurrentUserProfile: Boolean,
		specialties: {
			type: Array as PropType<string[]>,
			required: true,
		},
	},
	setup() {
		return {
			EditableSection,
		};
	},
});
